<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          مجتمع ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12"
                 sm="2"
                 v-if="can('newBuilding')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <create-building :model="model" :selected="selected" :dialogStatus.sync="showDialog"/>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                placeholder="نام مجتمع"
                v-model="searchvalue"
                @click:clear="clearable"

            />
            <v-btn  fab small color="primary" @click="fillDataItems" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col class="d-sm-inline-block" cols="12" sm="12"
                 md="6">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>


        <v-spacer/>
        <v-row>
          <v-col cols="12" sm="4" class="mb-2">
            <v-btn depressed small  color="success" @click="addUnit" class="mr-1 ">
              اضاضه و به روز کردن واحد ها
            </v-btn>
          </v-col>
        </v-row>
        <v-spacer/>
        <b-table
            v-if="can('buildingList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
             striped
        >
          <template #cell(actions)="row">
            <v-btn depressed small v-if="can('unitList')" color="warning" :to="{path:'/unit',query:{id:row.item.id}}" class="mr-1 ">
              لیست واحدها
            </v-btn>
            <v-btn depressed small v-if="can('editBuilding')" color="primary" @click="forEdit(row.item)" class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteBuilding')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CreateBuilding from './PageEdit'
import Building_se from "./Building_se";
import {mapMutations} from "vuex";



export default {
  name: 'Building',
  components: {
    CreateBuilding
  },
  data() {
    return {
      searchvalue: '',
      modelId: '',
      model: {},
      selected:[],
      buildingId:'all',
      showDialog: false,
      modelAtributes: {},
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'name', label: 'نام', sortable: true, sortDirection: 'desc'},
        {key: 'numberUnit', label: 'تعداد واحد', sortable: true, sortDirection: 'desc'},
        {key: 'startDateTxt', label: 'تاریخ شروع حساب در پنل', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('Building', () => {
      this.fillDataItems()
    })

  },

  methods: {

    close(){
      this.searchvalue=""
      this.$root.$emit('Building')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    addUnit() {
      this.$progress({message: 'درحال به روزرسانی واحد ها...'}, true)
      Building_se.addUnit().then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.$snack({type: 'success'})
        } else {
          this.$root.$emit('Progress')
          this.$snack({type: 'error'})
        }
      })

    },
    fetch() {
      Building_se.getById(this.modelId).then(response => {
        this.model = response.data.model
      })
      this.showDialog = true;
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()
    },

    forNew: function () {
      this.model = {};
      this.modelId = '';
      this.fetch()
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Building_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },
    clearable(){
      this.searchvalue=''
      this.fillDataItems()
    },
    fillDataItems() {
     Building_se.getPage( this.skip - 1, this.take,this.searchvalue).then(response => {
        this.paging = response.data.page
        this.dataItems = response.data.buildingList

      });
    },


  },

  created() {
   this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
